import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex/column';
import { InteractablePopover } from 'ui-components/components/interactable-popover';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import messages from '../../../../messages';
import styles from './store-defaults-cell.module.less';

type StoreForCell = {
  storeGuid: string;
  name: string;
};

type Props = {
  stores: StoreForCell[];
};

export const StoreDefaultsCell = ({ stores }: Props) => {
  const storeSettingsPath = (storeGuid: string) => `/settings/stores/${storeGuid}/storesettings`;

  if (stores.length === 0) {
    return '';
  }

  if (stores.length === 1) {
    const store = stores[0];
    return <Link to={storeSettingsPath(store.storeGuid)}>{store.name}</Link>;
  }

  return (
    <InteractablePopover
      ignoreTooltip
      popoverBody={
        <FlexColumn className={styles['popover-content-container']}>
          <FlexColumn className={styles['stores-list']}>
            {stores.map((store) => (
              <Link key={store.storeGuid} to={storeSettingsPath(store.storeGuid)}>
                {store.name}
              </Link>
            ))}
          </FlexColumn>
        </FlexColumn>
      }
      title={<FormattedMessage {...messages.storeDefaultsTitle} />}
    >
      <Button theme={THEME_CONSTANTS.link}>
        <FormattedMessage {...messages.storesCount} values={{ count: stores.length }} />
      </Button>
    </InteractablePopover>
  );
};
